import { Mermaid } from 'components/mermaid';
import {
  DosageScheduleQuery,
  DoseUnit,
  MedicineTradeName,
} from 'graphql/types';

export function formatDoseUnit(unit?: DoseUnit): string {
  switch (unit) {
    case 'MILLILITER':
      return 'mL';
    case 'MILLIGRAM':
      return 'mg';
    default:
      return '';
  }
}

function doseMermaidNode({
  variantId,
  variantName,
  medicineTradeName,
  doseId,
  quantity,
  unit,
}: {
  doseId: string;
  variantId: string;
  variantName: string;
  medicineTradeName?: MedicineTradeName;
  quantity: number;
  unit?: DoseUnit;
}): string {
  let node = `${doseId}["\``;
  node += `**ID: ${doseId.slice(-6)}**\n`;
  node += `**Variant:** ${variantName}\n`;
  node += `**Variant ID:** ${variantId.slice(-6)}\n`;
  node += `**Medicine:** ${medicineTradeName}\n`;
  node += `**Dose:** ${quantity} ${formatDoseUnit(unit)}`;
  node += `\`"]`;
  return node;
}

function doseMermaidEdge({
  startId,
  endId,
  intervalDays,
}: {
  startId: string;
  endId: string;
  intervalDays: number;
}): string {
  return `${startId} -- ${intervalDays} day${
    intervalDays !== 0 ? 's' : ''
  } -->${endId}`;
}

export function DosageScheduleMermaid({
  dosageSchedule,
}: {
  dosageSchedule: NonNullable<DosageScheduleQuery['dosageSchedule']>;
}): JSX.Element {
  return (
    <Mermaid key={dosageSchedule.id}>
      {`flowchart LR;
     ${dosageSchedule.doses
       .map((d) =>
         doseMermaidNode({
           doseId: d.id,
           variantId: d.variant?.id || '',
           variantName: d.variant?.name || '',
           medicineTradeName: d.dose?.medicineTradeName,
           quantity: d.dose?.quantity || 0,
           unit: d.dose?.unit,
         }),
       )
       .join('\n')}

     ${dosageSchedule.doses
       .filter((d) => d.nextDosageScheduleEventId)
       .map((d) =>
         doseMermaidEdge({
           endId: d.nextDosageScheduleEventId ?? '',
           startId: d.id,
           intervalDays: d.intervalDays ?? 0,
         }),
       )
       .join('\n')}
   `}
    </Mermaid>
  );
}
